import React, { useRef, useEffect } from 'react'
import styles from './ConversationalMode.module.scss'
import MessageList from './MessageList.tsx'
import { Message } from '../utils/conversationStorage.ts'
import type { DesktopSuggestion } from '../dashboardActionsConfig.tsx'

interface ConversationWindowProps {
  messages: Message[]
  onClose: () => void
  isLoading?: boolean
  matchedSuggestion?: DesktopSuggestion | null
  onSuggestionAction?: () => void
  allSuggestions?: DesktopSuggestion[]
  hasReachedLimit?: boolean
  remainingMessages?: number
  limit?: number
  userData?: any
}

const ConversationWindow: React.FC<ConversationWindowProps> = ({
  messages,
  onClose,
  isLoading = false,
  matchedSuggestion,
  onSuggestionAction,
  allSuggestions = [],
  hasReachedLimit = false,
  remainingMessages = 0,
  limit = 0,
  userData
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  return (
    <div className={styles.messagesContainer}>
      <MessageList 
        messages={messages} 
        isLoading={isLoading}
        matchedSuggestion={matchedSuggestion}
        onSuggestionAction={onSuggestionAction}
        allSuggestions={allSuggestions}
        hasReachedLimit={hasReachedLimit}
        remainingMessages={remainingMessages}
        limit={limit}
        userData={userData}
      />
      <div ref={messagesEndRef} />
    </div>
  )
}

export default ConversationWindow
